import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { trackEvent } from '../utils/tracking';
import './OfferCard.css';

export default function OfferCard({ offer }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(offer.code);
    } catch {
      // clipboard API unavailable — copying is best-effort, code is still visible to type manually
    }
    setCopied(true);
    trackEvent('Offer Code Copied', { partner: offer.partner });
    setTimeout(() => setCopied(false), 2000);
  };

  const handleGetDeal = () => {
    trackEvent('Offer Clicked', { partner: offer.partner });
  };

  return (
    <div className="card tp-offer-card">
      <img src={offer.logo} alt={offer.partner} className="tp-offer-card__logo" />
      <h3 className="title-m">{offer.headline}</h3>
      <p className="body-s tp-offer-card__description">{offer.description}</p>
      <button type="button" className="chip tp-offer-card__code" onClick={handleCopy}>
        <span>{offer.code}</span>
        {copied ? <Check size={14} strokeWidth={1.5} /> : <Copy size={14} strokeWidth={1.5} />}
      </button>
      <a
        href={offer.url}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-ghost tp-offer-card__cta"
        onClick={handleGetDeal}
      >
        Get this deal
      </a>
    </div>
  );
}
